import { itemOptionType } from '@/lib/item/server'
import { formatColorAndSize } from '@/lib/item/util'

// 商品オプションの表示
export const ItemOption = ({
  option,
  showPrice = true,
}: {
  option: itemOptionType
  showPrice?: boolean
}) => {
  return (
    <>
      <span className="mr-2">{option.name}</span>
      {formatColorAndSize(option)}
      {showPrice && (
        <span className="ml-2">{option.price.toLocaleString()}円</span>
      )}
    </>
  )
}
